import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Navbar.css';
import { LOGO, LOGO_SRCSET } from '../lib/imagenes';

// ?v=2 obliga a los navegadores y a Cloudflare a bajar el logo nuevo (sin fondo)

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  if (!user) return null;
  const isActive = (p) => location.pathname.startsWith(p);
  const go = (path) => { navigate(path); setOpen(false); };

  const planLabel = user.is_influencer ? '👑 Influencer' : user.plan === 'premium' ? '🧉 Premium' : user.plan === 'mate' ? '☕ Mate' : null;

  return (
    <nav className="navbar">
      <div className="navbar-inner container">
        <button className="navbar-brand" onClick={() => go('/explorar')}>
          <img src={LOGO} srcSet={LOGO_SRCSET} sizes="40px" alt="Logo" className="brand-logo" />
          <span className="brand-text">Cupido con Mate</span>
        </button>

        {/* En computadora las secciones van en dos filas: 10 secciones (11 con Admin) */}
        <div className={`navbar-links ${open ? 'open' : ''}`} style={{ '--nav-cols': user.role === 'admin' ? 6 : 5 }}>
          <button className={`nav-link ${isActive('/explorar') ? 'active' : ''}`} onClick={() => go('/explorar')}>
            🔍 Explorar
          </button>
          <button className={`nav-link ${isActive('/chat') ? 'active' : ''}`} onClick={() => go('/chat')}>
            💬 Chat
          </button>
          <button
            className={`nav-link ${isActive('/explorar') && location.search === '?tab=liked-me' ? 'active' : ''}`}
            onClick={() => go('/explorar?tab=liked-me')}
            title={user.plan !== 'premium' ? 'Exclusivo Plan Premium' : 'Quién te dio me gusta'}
          >
            💛 Me gusta {user.plan !== 'premium' && <span style={{ fontSize: 11 }}>🔒</span>}
          </button>
          <button
            className={`nav-link ${isActive('/explorar') && location.search === '?tab=viewers' ? 'active' : ''}`}
            onClick={() => go('/explorar?tab=viewers')}
            title="Quién te vio"
          >
            👁️ Vistas
          </button>
          <button
            className={`nav-link ${isActive('/explorar') && location.search === '?tab=standouts' ? 'active' : ''}`}
            onClick={() => go('/explorar?tab=standouts')}
            title="Perfiles destacados"
          >
            ⭐ Destacados
          </button>
          <button className={`nav-link ${isActive('/afinidad') ? 'active' : ''}`} onClick={() => go('/afinidad')} title="Test de afinidad sanjuanino">
            💞 Afinidad
          </button>
          <button className={`nav-link ${isActive('/mis-descuentos') ? 'active' : ''}`} onClick={() => go('/mis-descuentos')} title="Cupido Descuentos">
            🏷️ Descuentos
          </button>
          <button className={`nav-link ${isActive('/regalos') ? 'active' : ''}`} onClick={() => go('/regalos')}>
            🎁 Regalos y +
          </button>
          <button className={`nav-link ${isActive('/suscripcion') ? 'active' : ''}`} onClick={() => go('/suscripcion')}>
            {planLabel || '💳 Planes'}
          </button>
          <button className={`nav-link ${isActive('/ayuda') ? 'active' : ''}`} onClick={() => go('/ayuda')} title="Centro de ayuda">
            ❓ Ayuda
          </button>
          {user.role === 'admin' && (
            <button className={`nav-link ${isActive('/admin') ? 'active' : ''}`} onClick={() => go('/admin')}>
              🛡️ Admin
            </button>
          )}

          <div className="nav-user">
            <div className="nav-avatar" onClick={() => go('/perfil/setup')} title="Editar perfil">
              {user.foto_path
                ? <img src={user.foto_path} alt={user.name} />
                : <span>{(user.name || 'U')[0].toUpperCase()}</span>
              }
            </div>
            <span style={{ fontSize: 13, color: 'var(--texto-suave)', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user.name}
            </span>
            <button className="nav-link nav-logout" onClick={() => logout().then(() => navigate('/'))}>
              Salir
            </button>
          </div>
        </div>

        <button className="navbar-hamburger" onClick={() => setOpen(o => !o)} aria-label="Menú">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
